import { useState } from "react";
import { Button, CircularProgress, InputLabel, TextField } from "@mui/material";
import { useMutation } from 'react-query'
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { duplicate, searchMenuName } from "../services/api";
import { useTranslation } from "react-i18next";
import { ExistMenuName } from "components/Menu/ExistMenuName";

export default function Duplicate({ open, close, instance, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [nameMenu, setNameMenu] = useState("")
  const [existName, setExistName] = useState(false)

  const mutation = useMutation(duplicate, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const mutationMenuName = useMutation(searchMenuName, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'No se ha podido comprobar que ya exista el nombre seleccionado en otro menu', 'error')
        setExistName(false)
      } else {
        if (data.data) { setExistName(true) } else { setExistName(false) }
      }
    }
  })

  const handleCopy = () => {
    setIsLoading(true)
    mutation.mutate({ id: instance._id, name: nameMenu })
  }

  const handleClose = () => { setNameMenu(""); close() }

  const handleNameInput = (e) => {
    setNameMenu(e.target.value)
    mutationMenuName.mutate({ name: e.target.value })
  }

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t('button_text_cancel')}</Button>
      <Button variant="contained" color="info" disabled={nameMenu === "" || existName === true} onClick={() => handleCopy()}>{t('button_text_duplicate')}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={t('menu_dialog_title_duplicate')} actions={<Actions />}>
      <>
        <InputLabel htmlFor="menu_duplicate_name" required style={{ fontSize: 14 }}>Nombre del menú</InputLabel>
        <TextField
          fullWidth
          id="menu_duplicate_name"
          margin="dense"
          size="small"
          name="menu_duplicate_name"
          value={nameMenu || ""}
          onChange={handleNameInput} />
        {nameMenu !== "" ?
          <ExistMenuName
            exist={existName}
            messageExist={t('menu_duplicate_name_exist')}
            messageNoExist={t('menu_duplicate_name_not_exist')} />
          : null}
      </>
    </FlexibleWidthDialog>
  </>)
}